import { render, staticRenderFns } from "./RsaConfigurazioneTipoPrestazioneModalEditComponent.vue?vue&type=template&id=59dcc641"
import script from "./RsaConfigurazioneTipoPrestazioneModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTipoPrestazioneModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports